module.exports = __webpack_public_path__ + "img/water.0a0948a3.svg";